<template>
    <div>
        <b-modal
            centered
            no-close-on-backdrop
            no-close-on-esc
            hide-footer
            hide-header
            v-model="confirm.show"
            @hidden="closeModalConfirm()"
        >
            <card shadow type="secondary" class="m--4">
                <span class="close cursor-pointer" @click="confirm.show = false">&times;</span>
                <div class="row text-center">
                    <div class="col-lg-12 py-4">
                        <div v-html="confirm.icon"></div>
                    </div>
                    <div class="col-lg-12">
                        <h2>{{confirm.emphasize}}</h2>
                        <p v-html="confirm.text"></p>
                    </div>
                    <div class="col-lg-12 py-4">
                        <b-button 
                            :variant="confirm.hasOwnProperty('btnCancel') ? confirm.btnCancel.color : 'outline-primary'" 
                            class="px-4" 
                            @click="closeModalConfirm()"
                        >
                            {{ (confirm.btnCancelText) ? confirm.btnCancelText: 'ยกเลิก' }}
                        </b-button>
                        <b-button 
                            type="submit" 
                            :variant="confirm.hasOwnProperty('btnConfirm') ? confirm.btnConfirm.color : 'primary' " 
                            class="px-4 mx-2" 
                            @click=" $emit('confirmModal')"
                            :disabled="confirm.isLoad"
                        >
                            <i class="fas fa-circle-notch fa-spin" v-if="confirm.isLoad"></i> 
                            {{ (confirm.btnConfirmText) ? confirm.btnConfirmText: 'ยืนยัน' }}
                        </b-button>
                    </div>
                </div>
            </card>
            
        </b-modal>
    </div>
</template>
<script>
export default {
    props: {
        confirm: {
            type: Object
        }
    },
    methods: {
        closeModalConfirm(){
            this.confirm.show = false
            this.confirm.icon = ""
            this.confirm.emphasize = ""
            this.confirm.text = ""
            this.confirm.btnCancelText = ""
            this.confirm.btnConfirmText = ""
            this.confirm.isLoad = false
            this.confirm.id = null
        },
    }
}
</script>
